export function handlePermission(perms, permission) {
  const isPermissionIncluded = perms?.some((permissionToCheck) => permissionToCheck.codename === permission);
  return isPermissionIncluded;
}
